import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';
import { FiltersFormOperator } from 'system/view-models/operator-list';

export const initialValuesOperator: FiltersFormOperator = {
  service: '',
  qualification: '',
  code: '',
  serviceCode: null,
  name: '',
  page: 0,
  rowsPerPage: 10,
  totalCount: 10,
  codana: '',
};

const PageOperatorsInitializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValuesOperator}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageOperatorsInitializer.displayName = 'Page operators initializer component';

export default PageOperatorsInitializer;
